import logo from '../images/login/login-img.jpg';
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../css/Login.css';
import { Router, Switch, Route } from "react-router-dom";
import history from "../Components/history";
import SignIn from "../Components/login_components/SignIn";
import SignupComponent from "../Components/SignupComponent";


function LoginPage() {

  const appName = "";
  return (
    <Router history={history}>
      <div className="App">
        <div className="div-login-container">
          <div className="div-img-container">
            <img src={logo}></img>
          </div>
          <div className="div-auth-container">
            <div className="auth-wrapper">
              <div className="auth-inner">
                <Switch>
                  <Route exact path={appName} component={SignIn} />
                  <Route path={appName + "/login"} component={SignIn} />
                  <Route path={appName + "/login/sign-up"} component={SignupComponent} />
                </Switch>
              </div>
            </div>
          </div>

        </div>
      </div>
    </Router>
  );
}

export default LoginPage;
